import type { ConvertedCourseData } from "@/features/client-config/types/client-config";

export const originPositionFromFirstTee = (
  convertedCourseData: ConvertedCourseData | undefined
): { lat: number; lon: number } | undefined => {
  const position = convertedCourseData?.teeBoxes[0]?.position;
  if (!position) {
    return undefined;
  }
  return { lon: position[0], lat: position[1] };
};
